import React from "react";
const NoRoute = () => {
  return <>NO ROUTE FOUND. Please Go Back</>;
};
export default NoRoute;
